module.exports = __webpack_public_path__ + "static/media/logo.ca7f7361.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Editor/components/SidePanel/img/logo.svg
// module id = 220
// module chunks = 0